import React, { useState, useEffect } from "react";
import Input from "../../../../core/Inputs/DefaultInput";
import Svg from "../../../../component/common/Svg";
import { useDispatch, useSelector } from "react-redux";
import {
  addUtmVariable,
  deleteUtmVariable,
  getUtmVariable,
  updateUtmVariable,
} from "../../../../store/actions/variableAction";
import { getTokenData } from "../../../../store/actions/authAction";
import { useParams } from "react-router-dom";
import style from "../../../style.module.css";
import Card from "../../../../core/Card";
import { useTranslation } from "react-i18next";

export default function GroupUtmVariables() {
  const { groupId } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // States
  const [utmVeriables1, setUtmVeriables1] = useState([]);
  const [utmVeriables2, setUtmVeriables2] = useState([]);
  const [utmVeriables3, setUtmVeriables3] = useState([]);
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);
  const [counter3, setCounter3] = useState(0);
  const [utm1, setUtm1] = useState("");
  const [utm2, setUtm2] = useState("");
  const [utm3, setUtm3] = useState("");
  const [utmType, setutmType] = useState("");
  const [utmUpdateVariable, setutmUpdateVariable] = useState("");
  const [utmUpdateVariableId, setutmUpdateVariableId] = useState("");
  const [userId, setuserId] = useState("");
  const [error, setError] = useState("");
  const [currentlyDeletingUTMType, setCurrentlyDeletingUTMType] =
    useState("VAR");
  const [currentlyDeletingUTMVar, setCurrentlyDeletingUTMVar] = useState(null);
  const [currentlyDeletingUTMField, setCurrentlyDeletingUTMField] =
    useState(null);

  // Selectors
  const utmVariableData = useSelector(
    (state) => state.variables?.utmVariableData || []
  );
  const utmVariableLoading = useSelector(
    (state) => state.variables?.getUtmVariableLoading
  );
  const { groupDetail } = useSelector((state) => state.surveyGroupData);

  // Clear all states
  const clearUtm = () => {
    setUtm1("");
    setUtm2("");
    setUtm3("");
    setutmType("");
    setutmUpdateVariable("");
    setutmUpdateVariableId("");
    setCounter1(0);
    setCounter2(0);
    setCounter3(0);
    setUtmVeriables1([]);
    setUtmVeriables2([]);
    setUtmVeriables3([]);
  };

  const handleUpdateField = (e, suv_id) => {
    setutmUpdateVariable(e.target.value);
    setutmUpdateVariableId(suv_id);
  };

  const afterUpdateData = () => {
    clearUtm();
  };

  const afterAddData = () => {
    clearUtm();
    fetchVeriables();
  };

  const updateInput = () => {
    const payload = {
      su_var_name: utmUpdateVariable,
      su_suv_id: utmUpdateVariableId,
      group_id: groupId, // For group context
      link_scope: "group",
    };
    setError("");
    dispatch(updateUtmVariable(payload, afterUpdateData, errorCallback));
  };

  const errorCallback = (msg) => {
    setError(msg);
  };

  const handleChange = (e, type) => {
    if (Number(type) === 1) {
      setUtm1(e.target.value);
    }
    if (Number(type) === 2) {
      setUtm2(e.target.value);
    }
    if (Number(type) === 3) {
      setUtm3(e.target.value);
    }
    setutmType(type);
  };

  const insertInput = () => {
    const payload = {
      su_suv_type: utmType,
      su_var_name: utmType === 1 ? utm1 : utmType === 2 ? utm2 : utm3,
      su_added_by: userId,
      su_group_id: groupId, // For group context
      link_scope: "group",
    };
    setError("");
     dispatch(addUtmVariable(payload, afterAddData, errorCallback));
  };

  const addNewField = (counterNumber) => {
    if (counterNumber === 1 && counter1 < 1) {
      setCounter1(counter1 + 1);
    }
    if (counterNumber === 2 && counter2 < 1) {
      setCounter2(counter2 + 1);
    }
    if (counterNumber === 3 && counter3 < 1) {
      setCounter3(counter3 + 1);
    }
  };

  const deleteField = (counterNumber) => {
    if (counterNumber === 1) {
      setCounter1(counter1 - 1);
    }
    if (counterNumber === 2) {
      setCounter2(counter2 - 1);
    }
    if (counterNumber === 3) {
      setCounter3(counter3 - 1);
    }
  };

  const afterDeleteData = () => {
    setUtmVeriables1([]);
    setUtmVeriables2([]);
    setUtmVeriables3([]);
    fetchVeriables(); // Fetch updated list after deletion
  };

  const handleDeleteVar = (id) => {
    setCurrentlyDeletingUTMField(null);
    setCurrentlyDeletingUTMVar(id);
    setCurrentlyDeletingUTMType("VAR");
  };

  const handleDeleteField = (id) => {
    setCurrentlyDeletingUTMField(id);
    setCurrentlyDeletingUTMVar(null);
    setCurrentlyDeletingUTMType("FIELD");
  };

  const handleCancelPrompt = () => {
    setCurrentlyDeletingUTMField(null);
    setCurrentlyDeletingUTMVar(null);
    setCurrentlyDeletingUTMType("VAR");
  };

  const handleDeletePrompt = (crtType, crtVar, crtField) => {
    if (crtType === "VAR") {
      deleteVariable(crtVar);
    } else {
      deleteField(crtField);
    }
    handleCancelPrompt();
  };

  const deleteVariable = (value) => {
    dispatch(deleteUtmVariable(value, afterDeleteData));
  };

  const fetchVeriables = () => {
    // Pass group context to fetch group-specific UTM variables
    dispatch(getUtmVariable(null, groupId, "group"));
  };

  // Fetch UTM variables on mount
  useEffect(() => {
    if (groupId) {
      fetchVeriables();
      clearUtm();
    }
  }, [groupId]);

  useEffect(() => {
    dispatch(getTokenData(setuserId));
  }, [dispatch]);

  useEffect(() => {
    let type1 = [],
      type2 = [],
      type3 = [];
    utmVariableData.length > 0 &&
      utmVariableData.forEach((variable) => {
        if (variable.su_suv_type === 1) {
          type1 = [...type1, variable];
        }
        if (variable.su_suv_type === 2) {
          type2 = [...type2, variable];
        }
        if (variable.su_suv_type === 3) {
          type3 = [...type3, variable];
        }
      });

    setUtmVeriables1(type1);
    setUtmVeriables2(type2);
    setUtmVeriables3(type3);
  }, [utmVariableData]);

  return (
    <>
      <div className="survey-main-container">
        <div className="page-content-wrap variables-main-container p-0">
          <div className="main-sec-wrap">
            <div className="page-heading">
              <h1 className="mb-0 mb-lg-3">
                {t("survey.utm.title") || "UTM Campaign Variables"}
              </h1>
              <p>
                {t("survey.utm.text") ||
                  "Track the source and medium of your survey campaigns for better insights and data analysis."}
              </p>
            </div>
            {error && (
              <span className="text-danger mb-3 d-block">
                UTM variable already exists with this name.
              </span>
            )}
            {utmVariableLoading ? (
              <h1 className="loading-text">Loading...</h1>
            ) : (
              <div className="row pagesRow varPg">
                {/* Source Section */}
                <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">
                  <div className="campaign-head">
                    {t("survey.utm.source") || "Source"}
                  </div>
                  <div className="fullcomp">
                    {utmVeriables1.map((utmVar, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            value={utmVar.su_var_name}
                            fill
                            className={"formsinput"}
                            onChange={(e) =>
                              handleUpdateField(e, utmVar.su_suv_id)
                            }
                            onBlur={updateInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteVar(utmVar.su_suv_id)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    {Array.from(Array(counter1)).map((c, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            name={index}
                            fill
                            className={"formsinput"}
                            value={utm1}
                            onChange={(e) => handleChange(e, 1)}
                            onBlur={insertInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteField(1)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="utmAddBtn btn btn-bordered"
                      onClick={() => addNewField(1)}
                    >
                      {t("survey.utm.add") || "+ Add"}
                    </button>
                  </div>
                </div>

                {/* Medium Section */}
                <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">
                  <div className="campaign-head">
                    {t("survey.utm.medium") || "Medium"}
                  </div>
                  <div className="fullcomp">
                    {utmVeriables2.map((utmVar, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            value={utmVar.su_var_name}
                            fill
                            className={"formsinput"}
                            onChange={(e) =>
                              handleUpdateField(e, utmVar.su_suv_id)
                            }
                            onBlur={updateInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteVar(utmVar.su_suv_id)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    {Array.from(Array(counter2)).map((c, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            name={index}
                            fill
                            className={"formsinput"}
                            value={utm2}
                            onChange={(e) => handleChange(e, 2)}
                            onBlur={insertInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteField(2)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="utmAddBtn btn btn-bordered"
                      onClick={() => addNewField(2)}
                    >
                      {t("survey.utm.add") || "+ Add"}
                    </button>
                  </div>
                </div>

                {/* Campaign Section */}
                <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">
                  <div className="campaign-head">
                    {t("survey.utm.campaign") || "Campaign"}
                  </div>
                  <div className="fullcomp">
                    {utmVeriables3.map((utmVar, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            value={utmVar.su_var_name}
                            fill
                            className={"formsinput"}
                            onChange={(e) =>
                              handleUpdateField(e, utmVar.su_suv_id)
                            }
                            onBlur={updateInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteVar(utmVar.su_suv_id)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    {Array.from(Array(counter3)).map((c, index) => (
                      <div className="campaign-box" key={index}>
                        <div className="inputDelete d-flex align-items-center">
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder=""
                            name={index}
                            fill
                            className={"formsinput"}
                            value={utm3}
                            onChange={(e) => handleChange(e, 3)}
                            onBlur={insertInput}
                          />
                          <button
                            type="button"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteUTMModal"
                            className="btn minusIcon"
                            onClick={() => handleDeleteField(3)}
                          >
                            <Svg name="minus" />
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="utmAddBtn btn btn-bordered"
                      onClick={() => addNewField(3)}
                    >
                      {t("survey.utm.add") || "+ Add"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteUTMModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-sm" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>
                          {t("survey.customFormula.delete") ||
                            "Delete UTM Variable"}
                        </h3>
                        <p>
                          {t("survey.utm.text1") ||
                            "Are you sure you want to delete this UTM variable?"}
                        </p>
                      </div>
                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered"
                          data-bs-dismiss="modal"
                          onClick={() => handleCancelPrompt()}
                        >
                          {t("survey.customVariable.cancel") || "Cancel"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          data-bs-dismiss="modal"
                          onClick={() =>
                            handleDeletePrompt(
                              currentlyDeletingUTMType,
                              currentlyDeletingUTMVar,
                              currentlyDeletingUTMField
                            )
                          }
                        >
                          {t("survey.customVariable.confirm_delete") ||
                            "Delete"}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
